import { loginApi } from '../../setup/setupApi';
import { CustomStorageSettingsFields } from './types';

export const getCustomStorageSettings = (projectId: string): Promise<CustomStorageSettingsFields> =>
  loginApi.get(`projects/${projectId}/settings/custom_storage`).then((res) => res.data);

export const postCustomStorageSettings = (
  projectId: string,
  settings: { [key: string]: string | number | boolean | null }[]
): Promise<boolean> =>
  loginApi.post(`projects/${projectId}/settings/custom_storage`, settings).then((res) => true);
